// import React, { useEffect, useState } from "react";

// const Select = ({ options, value, setValue }) => {
//   const [selectedOp, setSelectedOp] = useState(-1); //indice de valor seleccionado
//   //const [optionSelected, setOptionSelected] = useState(false); //booleano de seleccion de opcion

//   const changeVal = (e) => {
//     setValue(e); //funcion definida en componente padre
//     //setOptionSelected(true); //solo para el text-color
//   };

//   useEffect(() => {
//     //carga inicial en caso reciba valor seleccionado
//     for (let i = 0; i < options.length; i++) {
//       if (value && options[i].text === `${value}`) setSelectedOp(i);
//     }
//   }, []);

//   return (
//     <select
//       value={options[selectedOp]}
//       defaultValue={options[0]}
//       onChange={changeVal}
//       className={`text-white bg-dark-green hover:light-green flex flex-row  max-w-[200px] w-full items-center  rounded-full font-poppins
//             py-4 px-6 text-lg font-bold accent-white`}
//     >
//       {options.map((op, i) => {
//         return (
//           <option
//             className="text-dark-green bg-white px-2"
//             key={i + 1}
//             value={op.value}
//             onClick={() => setSelectedOp(i)}
//           >
//             {op.text}
//           </option>
//         );
//       })}
//     </select>
//   );
// };

// export default Select;
import React, { useEffect, useState } from "react";

const Select = ({ options, setValue, initialValue }) => {
  const [selectedOp, setSelectedOp] = useState(initialValue || "");
  const [optionSelected, setOptionSelected] = useState(false);

  useEffect(() => {
    // Establecer el `selectedOp` inicial si `initialValue` existe en las `options`
    if (initialValue && options.some((op) => op.value === initialValue)) {
      setSelectedOp(initialValue);
      setOptionSelected(true);
    }
  }, [initialValue, options]);

  const changeVal = (e) => {
    const selectedValue = e.target.value;
    setSelectedOp(selectedValue);
    setValue(e);
    setOptionSelected(true);
  };

  const reset = () => {
    setSelectedOp("");
    setValue({ target: { value: "" } });
    setOptionSelected(false);
  };

  return (
    <select
      value={selectedOp}
      onChange={changeVal}
      className={`text-white bg-dark-green hover:light-green flex flex-row  max-w-[200px] w-full items-center  rounded-full font-poppins py-4 px-6 text-lg font-bold accent-white`}
    >
      {options.map((op, i) => {
        return (
          <option
            className="text-dark-green bg-white px-2"
            key={i + 1}
            value={op.value}
            onClick={() => setSelectedOp(i)}
          >
            {op.text}
          </option>
        );
      })}
    </select>
  );
};

export default Select;
